import * as S from './styles';
//Components
import TitleDash from '../../components/Title/TitleDash';
import AmountItems from '../../components/DashboardSection/AmountItems';
//icons
import {
    Screwdriver,
    UsersThree,
    ShoppingCart,
    Eyeglasses,
    CircleHalfTilt,
    Gift,
} from "@phosphor-icons/react";
// Gráficos - usando Recharts
import {
    ComposedChart,
    Line,
    Area,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';

export default function Dashboard() {
    // Dados de exemplo para o gráfico
    const data = [
        { name: 'Jan', vendas: 20 },
        { name: 'Fev', vendas: 35 },
        { name: 'Mar', vendas: 28 },
        { name: 'Abr', vendas: 42 },
        { name: 'Mai', vendas: 30 },
        { name: 'Jun', vendas: 38 },
    ];

    const data1 = [
        {
          name: 'Page A',
          uv: 590,
          pv: 800,
          amt: 1400,
        },
        {
          name: 'Page B',
          uv: 868,
          pv: 967,
          amt: 1506,
        },
        {
          name: 'Page C',
          uv: 1397,
          pv: 1098,
          amt: 989,
        },
        {
          name: 'Page D',
          uv: 1480,
          pv: 1200,
          amt: 1228,
        },
        {
          name: 'Page E',
          uv: 1520,
          pv: 1108,
          amt: 1100,
        },
        {
          name: 'Page F',
          uv: 1400,
          pv: 680,
          amt: 1700,
        },
      ];

    return (
        <S.Container>
            <TitleDash />

            <S.ContentItems>
                <AmountItems Icons={<Eyeglasses size={24} />} name='Armação' />
                <AmountItems Icons={<Screwdriver size={24} />} name='Serviço' />
                <AmountItems Icons={<Gift size={24} />} name='Acessório' />
                <AmountItems Icons={<CircleHalfTilt size={24} />} name='Lente' />
                <AmountItems Icons={<UsersThree size={24} />} name='Cliente' />
                <AmountItems Icons={<ShoppingCart size={24} />} name='Venda' />
            </S.ContentItems>

            <S.DividerGraph>
                <S.FrameGraph>
                    <S.LabelGraph>
                        Total de venda por mês <span>(R$)</span>
                    </S.LabelGraph>
                    <ResponsiveContainer width="100%" height="100%">
                        <ComposedChart
                            layout="vertical"
                            width={500}
                            height={400}
                            data={data1}
                            margin={{
                                top: 20,
                                right: 20,
                                bottom: 20,
                                left: 20,
                            }}
                        >
                            <CartesianGrid stroke="#f5f5f5" />
                            <XAxis type="number" />
                            <YAxis dataKey="name" type="category" scale="band" />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="pv" barSize={20} fill="#D4D4D8" />
                            <Line dataKey="uv" stroke="#ff7300" />
                        </ComposedChart>
                    </ResponsiveContainer>
                </S.FrameGraph>

                <S.FrameGraph>
                    <S.LabelGraph>
                        Total de venda por mês <span>(R$)</span>
                    </S.LabelGraph>

                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart
                            data={data}
                            margin={{
                                top: 20,
                                right: 30,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="vendas" fill="#8884d8" />
                        </BarChart>
                    </ResponsiveContainer>
                </S.FrameGraph>
            </S.DividerGraph>

        </S.Container>
    )
}